exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home .donations-summary .title{font-size:26px;margin:-2px 0 15px;line-height:22px}.home .donations-summary .title small{font-size:13px;display:block;margin:4px 1px 0 0;color:#3a7280}.donations-summary .table-container table{border-collapse:collapse;width:100%}.donations-summary .table-container table tr{font-size:18px;color:#3a7280;margin-top:10px;padding-bottom:3px;border-bottom:1px dashed #c3c3c3}.donations-summary .table-container table tr:last-child{border-bottom:0}.donations-summary .table-container table tr td{padding:5px 10px}.donations-summary .table-container table tr td .day-details{display:inline-block;font-size:12px;margin-right:5px}.donations-summary .table-container table tr .td-total{text-align:left;font-weight:600}.donations-summary .table-container table tr .td-total .currency{font-size:14px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/donations-summary/donations-summary.scss
// module id = 506
// module chunks = 0